module.exports = __webpack_public_path__ + "static/data-analytics-3-2c92ec894759d2471757656cdb52bbe7.svg";